<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/vrijheden/Asset 2.png" alt="">
    
    <span v-show="selected_text == -1">
      <img draggable="false" id="vrijheid_logo" src="./../../assets/images/vrijheden/Asset 1.png">
      <img draggable="false" class="clickable" id="vrijheid_play_btn" @click="showText()" src="./../../assets/images/Asset 57.png" alt="">
    </span>

    <span v-show="selected_text >= 0">
      <span v-if="selected_text == 0" id="eid_game_text">Dag der Vrijheden</span>
      <span v-html="texts[selected_text]" id="marron_game_intro_text" :style="selected_text > 0 ? 'margin-top: 7%;' : ''"></span>
      <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./../../assets/images/Asset 51.png" alt="">
      <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./../../assets/images/Asset 51.png" alt="">
    </span>
    
  </span>
</template>

<script>


export default {
  name: "VrijhedenStart",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      selected_text: -1,
      texts: [
        "Rond 1650 werden de eerste Afrikanen naar ons land vervoerd om te werken als slaaf. Op 1 juli 1863 werd de slavernij in Suriname afgeschaft en werden de tot slaaf gemaakten van hun slavenjuk bevrijd – ontdaan van hun ketens (Keti Koti).Ter gelegenheid van honderd jaar Keti Koti werd in 1963 in onze binnenstad een standbeeld onthuld. Het beeld van Kwakoe stelt een weggelopen en weer gevangen genomen tot slaaf gemaakte voor, die het symbool werd voor de drang naar vrijheid. ",

        "Bij de Ghanese Akan, de voorouders van veel tot slaaf gemaakte, is het gebruikelijk dat kinderen de naam dragen van de dag waarop ze geboren worden, zoals Kwassi/ Kwassiba voor een jongen/ meisje dat op zondag ter wereld kwam. Met name mannelijke nakomelingen die op woensdag werden geboren kregen de naam Kwakoe. Omdat 1 juli 1863 op een woensdag viel, heeft het beeld de naam Kwakoe gekregen.",

        "In Suriname heet deze dag officieel Dag der Vrijheden om zo deze dag voor alle inwoners van het land een feestdag te laten zijn en niet alleen voor de nazaten van de tot slaaf gemaakte. <br><br> Vrijheid is een mensenrechtDoordat ons land een koloniaal verleden heeft, kent het ook veel verhalen van verzet. Gelijk met de oplegging van het koloniale systeem in ons land begon voor vele van onze voorouders de strijd tegen onmenselijkheid, onderdrukking, slavernij en contractarbeid.Kaitjusi, Asykan Sylvester, Boni, Jan Houthakker Kodjo, Mentor en Present, Ramjanee, Tetary en vele andere dappere voorouders van wie wij de naam niet kennen hebben gestreden voor hun eigen vrijheid, dat van anderen en van ons.",
      ]
    };
  },

  methods: {
    goToStart() {
      this.$router.push('/start');
    },

    showText() {
      this.selected_text = 0
    },

    nextText() {
      this.selected_text++;
    },

    prevText() {
      this.selected_text--;
    },
  },

  computed: {}
};
</script>

<style>
  #eid_game_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 50%;
    left: 25%;
    color: white;
    font-size: 4vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #vrijheid_play_btn {
    position: absolute;
    margin-top: 42%;
    left: 44%;
    width: 15%;
  }
  #vrijheid_logo {
    position: absolute;
    margin-top: 5%;
    left: 43%;
    width: 15%;
  }
  #people {
    position: absolute;
    margin-top: 19.4%;
    left: 18.5%;
    width: 62%;
  }
</style>


